export default __webpack_public_path__ + "static/media/success-not-selected.29a66df2.svg";